<template>
  <div class="special">
      <div class="title-box">
        <div class="title">{{ list.name }}</div>
        <div><el-link :underline="false" class="more" :href="'#'+'/article'+list.url">更多 +</el-link></div>
      </div>
      <div class="body-box">
        <el-carousel height="150px">
          <template v-for="(item, index) in list.contents" :key="item.id">
            <el-carousel-item v-if="index <= 3">
              <a :href="'#'+'/article'+list.url+'/'+item.id">
                <el-image :src="item.image" fit="fill"></el-image>
              </a>
            </el-carousel-item>
          </template>
        </el-carousel>
      </div>
  </div>
</template>
<script>
export default ({
  name: "Show",
  props: {
    list: Object,
  },
  computed: {}
})
</script>

<style scoped>
.body-box {
  width: 364px;
  height: 130px;
  border: 1px solid #E3E3E3;
  padding: 10px;
}
.body-box .el-image {
  width: 100%;
  height: 130px;
}
.special {
  width: 386px;
  height: 130px;
  float: left;
}
.title-box {
  width: 386px;
  height: 36px;
  background: #F3F3F3;
  border-bottom: 2px solid #E3E3E3;
  margin-bottom: 10px;
}
.title {
  width: 100px;
  height: 34px;
  text-align: center;
  border-bottom:4px solid #BF2E11;
  float: left;
  color: #BF2E11;
  line-height: 34px;
  font-size: 18px;
  font-weight: bold;
}
.more {
  width: 60px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  float: right;
  font-size: 14px;
}
</style>